function Plus() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9996 2.19268C5.23997 2.19268 2.19219 5.24046 2.19219 9.00008C2.19219 12.7597 5.23997 15.8075 8.9996 15.8075C12.7592 15.8075 15.807 12.7597 15.807 9.00008C15.807 5.24046 12.7592 2.19268 8.9996 2.19268ZM0.992188 9.00008C0.992188 4.57771 4.57723 0.992676 8.9996 0.992676C13.422 0.992676 17.007 4.57771 17.007 9.00008C17.007 13.4225 13.422 17.0075 8.9996 17.0075C4.57723 17.0075 0.992188 13.4225 0.992188 9.00008ZM9.29589 5.14082C9.62726 5.14082 9.89589 5.40945 9.89589 5.74082V8.10379H12.2589C12.5902 8.10379 12.8589 8.37242 12.8589 8.70379C12.8589 9.03516 12.5902 9.30379 12.2589 9.30379H9.89589V12.2593C9.89589 12.5907 9.62726 12.8593 9.29589 12.8593C8.96452 12.8593 8.69589 12.5907 8.69589 12.2593V9.30379H5.74034C5.40896 9.30379 5.14034 9.03516 5.14034 8.70379C5.14034 8.37242 5.40896 8.10379 5.74034 8.10379H8.69589V5.74082C8.69589 5.40945 8.96452 5.14082 9.29589 5.14082Z"
        fill="#20293C"
      />
    </svg>
  );
}

export default Plus;
